// extracted by mini-css-extract-plugin
export default {"btn":"WhiteButton_btn__eirUr"};